import { func, string } from 'prop-types';
import { Plans } from '../../constants';
import Banner from '../Banner';
import PlanList from '../PlanList';
import * as styles from '../subscribe-today.module.scss';

const MobileLayout = ({ selectedPlan = Plans.ANNUAL, handlePlanChange = () => null }) => (
  <div className={styles['mobileLayout']} data-testid="mobile-layout">
    <Banner
      title="Love FabFitFun?"
      subtitle="Keep accessing amazing sales by becoming a FabFitFun member."
    />
    <PlanList selectedPlan={selectedPlan} handlePlanChange={handlePlanChange} />
  </div>
);

MobileLayout.propTypes = {
  selectedPlan: string,
  handlePlanChange: func,
  hostMemberName: string,
};

export default MobileLayout;
